// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "#app[data-v-19a86992]{height:100vh}", "",{"version":3,"sources":["/gaia/workspace-job/git.xiaojukeji.com/agility-fe/ut-webx/modules/ut-launch-slp/src/src/App.vue"],"names":[],"mappings":"AAgBA,sBACA,YACA","file":"App.vue","sourcesContent":["<template>\n  <div id=\"app\">\n    <router-view />\n  </div>\n</template>\n<script>\nexport default {\n  name: 'layout',\n  data () {\n    return {\n    }\n  }\n}\n</script>\n\n<style scoped>\n#app {\n  height: 100vh;\n}\n</style>"]}]);
// Exports
module.exports = exports;
